import { Navigate, useLocation, useSearchParams } from 'react-router-dom';

/**
 * `/tools/backtestStatus` used to be a standalone page that asked which strategy you meant. Its
 * content now lives on the strategy itself, so this only forwards old links and bookmarks. Callers
 * passed the strategy either as `?strategyId=` or through router state.
 */
const BacktestStatusRedirect = () => {
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const strategyIdFromSearchParams = (() => {
        const raw = searchParams.get('strategyId');
        if (!raw) return null;

        const parsed = Number(raw);

        return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : null;
    })();

    const strategyIdFromState = (() => {
        const state = location.state as { strategyId?: number } | null;
        const raw = state?.strategyId;

        return typeof raw === 'number' && Number.isSafeInteger(raw) && raw > 0 ? raw : null;
    })();

    const strategyId = strategyIdFromSearchParams ?? strategyIdFromState;

    // Without a strategy there is nothing to show; the list is where you pick one.
    if (strategyId === null) return <Navigate replace to="/user/tradingStrategies" />;

    return <Navigate replace to={`/user/tradingStrategy/${strategyId}?section=backtests`} />;
};

export default BacktestStatusRedirect;
